import React, { CSSProperties, useMemo } from "react";
import { makeStyles } from "@material-ui/core";

import { Image } from "../../Image";
import { usePageContext } from "../Context";



export interface HeaderCoverProps {
	coverTranslate: number,
	collapseProgress: number | undefined,
}


export const HeaderCover = (props: HeaderCoverProps) => {
	const { coverTranslate, collapseProgress } = props;
	const { pageMeta: { cover } } = usePageContext();
	const classes = useStyles();
	
	const coverImage = cover[1];
	const coverAlign = `${cover[2]}% ${cover[3]}%`;
	
	const coverStyle = useMemo(
		(): CSSProperties => ({
			transform: `translateY(${coverTranslate}px)`,
			opacity: collapseProgress === undefined ? undefined : (1 - collapseProgress * 0.5),
		}),
		[coverTranslate, collapseProgress],
	);

	return (
		<div className={classes.cover} style={coverStyle}>
			<Image
				file={coverImage}
				loading="eager"
				className={classes.background}
				objectFit="cover"
				objectPosition={coverAlign}
				alt=""
			/>
		</div>
	);
};

const offset = 0;

const useStyles = makeStyles(theme => ({

	cover: {
		position: "absolute",
		left: -offset, right: -offset,
		bottom: -offset, top: -offset,
		willChange: "transform",
	},

	background: {
		height: '100%',
	},

}));

